import { DesignSystem } from '@workbuddy/ui/v2/design-system';

const tokens = DesignSystem.tokens;

export const docZoomFrameStyleId = 'wb-doc-zoom-frame-theme';

export const docZoomFrameBridgeStyles = {
  'w-doc-zoom-frame': {
    '--local-doc-zoom-pill-bg': tokens.color.background.primary,
    '--local-doc-zoom-pill-border': tokens.color.border.primary,
    '--local-doc-zoom-pill-radius': tokens.radius.full,
    '--local-doc-zoom-pill-shadow': tokens.shadow.lg,
    '--local-doc-zoom-btn-color': tokens.color.text.secondary,
    '--local-doc-zoom-btn-hover-bg': tokens.color.background.secondary,
    '--local-doc-zoom-btn-radius': tokens.radius.full,
    '--local-doc-zoom-pct-radius': tokens.radius.md,
    '--local-doc-zoom-divider-bg': tokens.color.border.primary,
    // Used as `outline: 2px solid` (a colour), so map to the brand border colour — NOT focusRing.default,
    // which is a multi-layer box-shadow value and would be invalid in an outline.
    '--local-doc-zoom-focus-ring': tokens.color.border.brand,
  },
};
